import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const PdfEmbed = ({ embedURL }: any) => (
  <Container className="pdf-responsive">
    <iframe
      src={`https://reports-api.tatweertransit.com/pdfjs/web/viewer.html?file=${embedURL}`}
      frameBorder="0"
      title="Embedded pdf"
    />
  </Container>
);

PdfEmbed.propTypes = {
  embedURL: PropTypes.string.isRequired,
};

const Container = styled.div`
  position: relative;
  width: 100%;

  height: 300px;
  
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
`;

export default PdfEmbed;
